export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 mb-6">
            关于新新漫画
          </h2>
          <p className="text-[15px] leading-relaxed text-foreground-600 mb-4">
            新新漫画诞生于对漫画阅读体验的极致追求。我们深知每一位漫迷在浩如烟海的作品中找到心仪之作的不易——
            韩漫的细腻情感、日漫的热血冒险、国漫的东方美学，各有千秋却散落四方。
          </p>
          <p className="text-[15px] leading-relaxed text-foreground-600 mb-4">
            因此，我们打造了以<strong className="text-foreground-800">类型分类</strong>为核心的聚合阅读平台，
            将全网优质漫画按纯爱、奇幻、热血、悬疑、搞笑、都市等十余种类型精细整理，
            让你不再盲目搜索，而是像逛书架一样从容挑选。
          </p>
          <p className="text-[15px] leading-relaxed text-foreground-600">
            每日追踪上百部作品的更新动态，热门榜单实时刷新，一次收藏即可永久回看。
            新新漫画，就是让<strong className="text-foreground-800">找到好看漫画</strong>这件事变得简单而愉快。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 mt-8">
            <div className="flex items-center gap-2 text-foreground-500">
              <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
              <span className="text-[14px]">正版授权合作</span>
            </div>
            <div className="flex items-center gap-2 text-foreground-500">
              <i className="ri-shield-check-fill text-accent-500 text-lg"></i>
              <span className="text-[14px]">无广告纯净阅读</span>
            </div>
            <div className="flex items-center gap-2 text-foreground-500">
              <i className="ri-refresh-fill text-accent-500 text-lg"></i>
              <span className="text-[14px]">每日同步更新</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}